import React from 'react'
import { useStyles } from './TechlinkJobShowBannerMobile_style'
import { Typography, Box } from '@material-ui/core'
import TechlinkApplyButton from '../../../TechlinkApplyButton/TechlinkApplyButton'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const TechlinkJobShowBannerMobile = (props) => {
    const { user, job, unavailable, companyTechlinkUrl } = props
    const classes = useStyles()

    return (
        <Box className={classes.bannerContainer}>
            <RouteMapLink page={companyTechlinkUrl}>
                <Typography component='h2' className={classes.companyName}>
                    {job.company_name?.toUpperCase()}
                </Typography>
            </RouteMapLink>
            <Typography component='h1' className={classes.jobTitle}>
                {job.title}
            </Typography>
            {!unavailable && <Box className={classes.controlsContainer}>
                <Box className={classes.rightControlsContainer}>
                    <TechlinkApplyButton
                        containerClass={classes.applyButtonContainer}
                        job={job}
                        user={user}
                    />
                </Box>
            </Box>}
        </Box>
    )
}

export default TechlinkJobShowBannerMobile
